import { useMediaQuery, useTheme } from '@mui/material';

/**
 * True below the `md` breakpoint (< 900px) — phones and small tablets.
 *
 * One definition, used everywhere. Do not inline `useMediaQuery` in a page; if a page needs a
 * different threshold, that is a signal the design changed and this hook should change with it.
 */
export const useIsMobile = (): boolean => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
};

export default useIsMobile;
